export default "__VITE_ASSET__B7Ns7TCy__"